import styled, { css } from 'styled-components';

import { themeColor, themeZIndex, whenThemePropEqualsTrue } from '../../../../theme/getters';
import { basedOnHeaderTheme, headerTransition } from '../headerBar.styles';
import { Theme } from '../../../../modules/headerBar/themes';

export const Container = styled.div`
  position: absolute;
  width: 32px;
  height: 16px;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  z-index: ${themeZIndex('header')};
`;

export const Line = styled.span`
  position: absolute;
  height: 1px;
  width: 100%;
  transition: ${headerTransition};
  transform: rotate(0deg);
  transform-origin: 50% 50%;
  ${basedOnHeaderTheme({
    [Theme.LIGHT]: css`
      background-color: ${themeColor('white')};
    `,
    [Theme.FILLED]: css`
      background-color: ${themeColor('primary')};
    `,
  })};

  &:nth-child(1) {
    top: 0;
    width: 100%;
    left: 0;
  }

  &:nth-child(2),
  &:nth-child(3) {
    top: 8px;
  }

  &:nth-child(4) {
    top: 16px;
    width: 100%;
    left: 0;
  }

  ${whenThemePropEqualsTrue('isHamburgerOpen')(
    () => css`
      background-color: ${themeColor('primary')};

      &:nth-child(1) {
        top: 8px;
        width: 0;
        left: 50%;
      }

      &:nth-child(2) {
        transform: rotate(45deg);
      }

      &:nth-child(3) {
        transform: rotate(-45deg);
      }

      &:nth-child(4) {
        top: 8px;
        width: 0;
        left: 50%;
      }
    `
  )}
`;
